// Employee Activity FE module — API client.
// Calls the org-admin employee-activity endpoint using the logged-in user's TG JWT.
// The backend authorizes via role + org.employeeActivityEnabled and rate-limits refreshes.
import axios from 'axios';
import { SERVER_URL } from '../../utils/serverConfig';

const employeeActivityApi = axios.create({
  baseURL: `${SERVER_URL}/api/v1/stealth-agent/admin-session`,
  timeout: 20000,
});

employeeActivityApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

/** GET employee activity list — DESKTOP AGENT source. params: { q?, limit?, skip? } */
export const getEmployeeActivity = (params = {}) =>
  employeeActivityApi.get('/employee-activity', { params }).then((r) => r.data);

/**
 * GET app activity list — DESKTOP APPLICATION source. Same params + same response
 * shape as getEmployeeActivity, but Online means "tracking timer pinged in the
 * last 2 min" and `activity` is always null (no live active/idle on the app side).
 */
export const getAppActivity = (params = {}) =>
  employeeActivityApi.get('/app-activity', { params }).then((r) => r.data);

export default employeeActivityApi;
